const getStatusOption = (statusRules, status) => {
  const value = statusRules.find((rule) => rule.status === status);
  return convertOptionList(value ? [...value.allowedStatus, status] : [status]);
};

const getTerminalOption = (terminalRules, inboundTerminal) => {
  return convertOptionList(
    terminalRules.length > 0 ? [...terminalRules, inboundTerminal] : [inboundTerminal]
  );
};

const convertOptionList = (data) => {
  return data.map((value) => ({
    label: value,
    value: value
  }));
};

export { getStatusOption, getTerminalOption, convertOptionList };
